module.exports = __webpack_public_path__ + "static/media/in.cbed4eb1.jpeg";